import countries from '@translations/countries/countries_en.json';
import { ICountry } from '@app/interfaces/country.interface';

export function getCountryByIso2(iso2Code: string): ICountry {
  return iso2Code ? countries.find((country) => country.alpha2 === iso2Code.toLowerCase()) : null;
}
